import { ReduxFormState } from "rd-redux-forms";
import { FetchingState } from "rd-redux-http";
import { buildAdUnitRequest, getAdUnitsListRequest, getAdUnitByIdRequest } from "../../common";

export const defaultAdUnitBuilderState: AdUnitBuilderState = {
    assetForms: {
        main: undefined,
        nested: {}
    },
    adUnitBuilding: {
        fetchState: FetchingState.INITIAL
    },
    adUnitList: {
        fetchState: FetchingState.INITIAL
    },
    uploadingFileId: undefined,
    adUnitById: {
        fetchState: FetchingState.INITIAL
    }
};

export interface AdUnitBuilderState {
    assetForms: AssetFormState;
    adUnitBuilding: typeof buildAdUnitRequest.types.reduxState;
    adUnitList: typeof getAdUnitsListRequest.types.reduxState;
    /** Identifier of the input initiated file uploading */
    uploadingFileId: string | undefined;
    adUnitById: typeof getAdUnitByIdRequest.types.reduxState;
}

export interface AssetFormState {
    main: ReduxFormState<any> | undefined;
    nested: {
        [propertyName: string]: ReduxFormState<any>[];
    };
}
